// Propriétés du document : mêmes champs que l'ancien visualiseur, dans une boîte <dialog>
// (menu des outils). La taille vient du serveur (data-taille) : pdf.js n'a pas à lire tout le fichier.

const formatDate = new Intl.DateTimeFormat('fr-CA', { dateStyle: 'long', timeStyle: 'short' });
const formatNombre = new Intl.NumberFormat('fr-CA', { maximumFractionDigits: 2 });

function afficherTaille(octets) {
  if (!octets) return '';
  const ko = octets / 1024;
  const lisible = ko < 1024 ? `${formatNombre.format(ko)} ko` : `${formatNombre.format(ko / 1024)} Mo`;
  return `${lisible} (${formatNombre.format(octets)} octets)`;
}

export function initialiserProprietes(section, { pdf, pdfjsLib, fermerMenu }) {
  const bouton = section.querySelector('[data-action="proprietes"]');
  const boite  = section.querySelector('.pdf-proprietes');
  const liste  = boite.querySelector('.pdf-proprietes-liste');
  let rempli   = false;

  const afficherDate = (valeur) => {
    const date = pdfjsLib.PDFDateString.toDateObject(valeur);
    return date ? formatDate.format(date) : '';
  };

  const remplir = async () => {
    const { info } = await pdf.getMetadata();
    const fichier = section.dataset.fichier;
    const lignes = [
      ['Nom du fichier', fichier.slice(fichier.lastIndexOf('/') + 1)],
      ['Taille du fichier', afficherTaille(Number(section.dataset.taille))],
      ['Titre', info.Title],
      ['Auteur', info.Author],
      ['Sujet', info.Subject],
      ['Mots-clés', info.Keywords],
      ['Date de création', afficherDate(info.CreationDate)],
      ['Date de modification', afficherDate(info.ModDate)],
      ['Créé par', info.Creator],
      ['Outil de conversion PDF', info.Producer],
      ['Version PDF', info.PDFFormatVersion],
      ['Nombre de pages', String(pdf.numPages)],
    ];

    liste.replaceChildren(...lignes.flatMap(([libelle, valeur]) => {
      const dt = document.createElement('dt');
      const dd = document.createElement('dd');
      dt.textContent = libelle;
      dd.textContent = valeur || '-';
      return [dt, dd];
    }));
    rempli = true;
  };

  bouton.hidden = false;
  bouton.addEventListener('click', async () => {
    fermerMenu();
    if (!rempli) await remplir();
    boite.showModal();
  });
}
